const styles = (theme) => ({
  dataGrid: {
    minHeight: 150,
    height: 180,
    maxHeight: 240,
    border: `1px solid ${theme.AppBGColor}`,
    '& .ag-theme-material .ag-body-horizontal-scroll': {
      borderWidth: '0px'
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: '100%'
    },
    '& .statusBar': {
      display: 'none'
    },
    '& .ag-center-cols-viewport': {
      width: 'calc(100% + 18px)'
    }
  },
  driverCommentsGrid: {
    margin: '20px 0 60px 0',
    height: 300
  },
  gridHead: {
    padding: '5px 0px',
    minHeight: 24,
    marginBottom: 6,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  sectionTitle: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  statusBar: {
    marginTop: 4
  }
});

export default styles;
